import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { mandantsArraySchema } from 'back-office/shared/components/mandants/mandantsValidation';
import { addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';
import { PimFormFieldNames } from './PimFormFieldNames';
import { PimFormValues } from './PimFormValues';

import { gerantValidationRules, optionalCompanyPhoneRule } from 'back-office/shared/components/gerant/gerantFields';
export const pimValidationRules: ValidationRules<keyof PimFormValues> = {
  ...gerantValidationRules,
  ...addressValidationRules,
  [PimFormFieldNames.CompanyName]: Yup.string()
    .required('La raison sociale est requise')
    .min(2, 'La raison sociale doit contenir au moins 2 caractères'),
  [PimFormFieldNames.Phone]: optionalCompanyPhoneRule,
  [PimFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Le numéro SIRET est requis')
    .matches(/^\d{14}$/, 'Le SIRET doit contenir 14 chiffres'),
  [PimFormFieldNames.Capital]: Yup.number()
    .required('Le capital est requis')
    .min(0, 'Le capital doit être positif'),
  [PimFormFieldNames.RcsCity]: Yup.string()
    .required('La ville RCS est requise'),
  [PimFormFieldNames.RcsNumber]: Yup.string()
    .required('Le numéro RCS est requis'),
  [PimFormFieldNames.Rcp]: Yup.string()
    .nullable()
    .notRequired(),
  [PimFormFieldNames.ComplaintEmail]: Yup.string()
    .required("L'email de réclamation est requis")
    .email('Format email invalide'),
  [PimFormFieldNames.Mandants]: mandantsArraySchema,
  [PimFormFieldNames.FirstName]: Yup.string()
    .required('Le prénom est requis')
    .min(2, 'Le prénom doit contenir au moins 2 caractères'),
  [PimFormFieldNames.LastName]: Yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  [PimFormFieldNames.Email]: Yup.string()
    .required("L'email est requis")
    .email('Format email invalide'),
  [PimFormFieldNames.Username]: Yup.string()
    .required("Le nom d'utilisateur est requis")
    .min(3, "Le nom d'utilisateur doit contenir au moins 3 caractères"),
  [PimFormFieldNames.Password]: Yup.string()
    .required('Le mot de passe est requis')
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  // Les plateformes d'abord : chaque mandant doit en partager au moins une.
  [PimFormFieldNames.PlateformeIds]: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Au moins une plateforme est requise')
    .required('Les plateformes sont requises'),
};
